import { TAppError, IBaseAction } from '@/store/types/base.state';

export enum NavigationActionTypes {
  NAVIGATE = 'NAVIGATION.NAVIGATE',
  NAVIGATE_FAIL = 'NAVIGATION.NAVIGATE_FAIL',
  NAVIGATE_SUCCESS = 'NAVIGATION.NAVIGATE_SUCCESS',
}

export interface INavigateAction extends IBaseAction {
  type: typeof NavigationActionTypes.NAVIGATE;
}

export interface INavigateFailAction extends IBaseAction {
  type: typeof NavigationActionTypes.NAVIGATE_FAIL;
  error: TAppError;
}

export interface INavigateSuccessAction extends IBaseAction {
  type: typeof NavigationActionTypes.NAVIGATE_SUCCESS;
}

export type TNavigationAction = INavigateAction | INavigateFailAction | INavigateSuccessAction;
